import React from 'react';

const BatchDetails = (props) => {
return ( 
       <div>BatchDetails</div>
    ) 
}

export default BatchDetails;